import { IconsProps } from '@/types/shared'
import React from 'react'

const PptxIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="-2 -2 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.25 0C0.559644 0 0 0.559644 0 1.25V18.75C0 19.4404 0.559644 20 1.25 20H18.75C19.4404 20 20 19.4404 20 18.75V1.25C20 0.559644 19.4404 0 18.75 0H1.25ZM17.5 5.625H2.5V14.375H17.5V5.625Z"
                    fill="#FFA726"
                />
            </svg>
        </div>
    )
}

export default PptxIcons
